import { Box, Button, Text } from '@chakra-ui/react';
import React from 'react';
import { Close } from '../../Icons/Close';
import { CommonProps } from '../../interfaces/components';
import { useTranslation } from 'react-i18next';
import { disptchCTAClickObject } from '../../Analytics';

const ShoppingExpress = ({ active, setActive }: CommonProps) => {
  const { t } = useTranslation();

  const onBooking = () => {
    const url =
      'https://tickets.catalunyabusturistic.com/en/173/608?aff=shoppingexpress&utm_medium=afiliados&utm_campaign=Afiliados&utm_source=thebicestercollection.com';
    disptchCTAClickObject('laroca', 'Button', 'Shopping Express', 'Book', url);
    window.open(url, '_blank');
  };

  return (
    <>
      <Box
        position="fixed"
        w="100%"
        h="100%"
        top="0"
        left="0"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        backgroundColor="rgba(0,0,0,0.2)"
        transition="all 1s"
        zIndex={4}
        onClick={() => setActive()}
      />
      <Box
        zIndex={8}
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        transition="all 0.5s"
        position="fixed"
        top={0}
        right={0}
        left={0}
        bottom={0}
        margin="auto"
        backgroundColor="rgba(255, 255, 255, 1);"
        padding="15px 15px 40px 15px"
        width={['95vw', '400px', '510px', '800px', '800px']}
        height="max-content"
      >
        <Close
          boxSize={[6, 6, 7]}
          position="absolute"
          top={['30px', '30px', '30px']}
          right={['30px', '30px', '30px']}
          cursor="pointer"
          onClick={() => setActive()}
          zIndex={30}
        />
        <Text
          mt="10"
          pt="3"
          textAlign="center"
          fontWeight="300"
          fontFamily="SangBleuBPLight"
          className="copy"
          fontSize={['14px', '14px', '18px', '20px', '20px']}
          lineHeight={['20px', '20px', '24px', '26px', '26px']}
        >
          {t('shopping_express_title')}
        </Text>

        <Text
          mt="6"
          textAlign="center"
          fontWeight="400"
          fontFamily="JosefinSans"
          className="copy"
          fontSize={['12px', '12px', '14px', '16px', '16px']}
          lineHeight={['16px', '16px', '18px', '20px', '20px']}
          maxW="90%"
          mx="auto"
        >
          {t('shopping_express_description')}
        </Text>

        <Box display="flex" flexDir="column" justifyContent="center" alignItems="center" gap="3" mt="10">
          <Button
            bg="white"
            border="1px solid gray"
            borderRadius="0px"
            h="46px"
            px="30px"
            pt={['0', '0', '1']}
            color="#455255"
            _hover={{ bg: '#C29F6B', color: 'white', border: '1px solid #C29F6B' }}
            onClick={onBooking}
          >
            <Text
              textAlign="center"
              fontWeight="400"
              fontFamily="JosefinSans"
              textTransform="uppercase"
              fontSize={['12px', '12px', '14px', '14px', '14px']}
            >
              {t('shopping_express_btn')}
            </Text>
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default ShoppingExpress;
